export default "__VITE_ASSET__DyeC7NLG__"